import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { fetchUser } from '../features/auth/authSlice';
import Header from '../components/Header';
import { useAuth } from '../hooks/useAuth';

export const ProtectedRoute = () => {
  const [isTokenLoaded, setTokenLoaded] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, error, isLoading } = useAuth();

  useEffect(() => {
    const token = Cookies.get('token');

    if (token && !user) {
      dispatch(fetchUser());
    } else if (!token) {
      navigate('/sign-in');
    }
    setTokenLoaded(true);
  }, [dispatch, navigate, user, error]);

  useEffect(() => {
    if (error) {
      Cookies.remove('token');
      navigate('/sign-in');
    }
  }, [error, isLoading, navigate]);

  if (!isTokenLoaded) {
    return null;
  }

  if (!error && !isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          backgroundColor: '#fdfdfe',
        }}
      >
        <Header />
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Outlet />
        </div>
      </div>
    );
  }
};
